import { c as _c } from "react/compiler-runtime";
import { LogoIcon } from "~/components/icons/LogoIcon";
import { BrandText } from "~/components/ui/brand-text";
import { cn } from "~/lib/utils";
interface BrandLogoProps {
  className?: string; // Class for the container
  iconSize?: string; // Class for the icon size (e.g. "w-8 h-8")
  textSize?: "sm" | "default" | "lg" | "xl"; // Size for the text
  hideText?: boolean; // Option to hide text (responsive)
}

/**
 * Unified Brand Logo Component
 * Combines LogoIcon and BrandText with consistent styling and behavior.
 */
export function BrandLogo(t0) {
  const $ = _c(13);
  const {
    className,
    iconSize: t1,
    textSize: t2,
    hideText: t3
  } = t0;
  const iconSize = t1 === undefined ? "w-8 h-8" : t1;
  const textSize = t2 === undefined ? "default" : t2;
  const hideText = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== className) {
    t4 = cn("group flex items-center gap-2", className);
    $[0] = className;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== iconSize) {
    t5 = cn(iconSize, "transition-transform duration-200 group-hover:scale-105");
    $[2] = iconSize;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <LogoIcon className={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== hideText || $[7] !== textSize) {
    t7 = !hideText && <BrandText size={textSize} className="translate-y-[1px]" />;
    $[6] = hideText;
    $[7] = textSize;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t7) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}